import { z } from 'zod/v3';
import { makeFieldSchemaFromZod } from '../utils';

/** Put all uiSchema options here, in the template they go under ui:options: */
export const InfoBannerUiOptionsSchema = z.object({
  severity: z
    .enum(['info', 'warning', 'error', 'success'])
    .optional()
    .describe('The alert severity. Defaults to "info".'),
  title: z
    .string()
    .optional()
    .describe('Bold title text shown inside the banner.'),
  description: z
    .string()
    .optional()
    .describe('Body text shown below the title.'),
  linkText: z
    .string()
    .optional()
    .describe('Label for the external link button.'),
  linkUrl: z
    .string()
    .optional()
    .describe('URL the external link button navigates to.'),
});

/** Transforms the Zod schema to a TypeScript type */
export type InfoBannerUiOptions = z.infer<typeof InfoBannerUiOptionsSchema>;

/** The field schema for the InfoBanner field extension */
export const InfoBannerFieldSchema = makeFieldSchemaFromZod(
  z
    .string()
    .optional()
    .describe('Display-only banner field configured through ui:options.'),
  InfoBannerUiOptionsSchema,
);

/** Transforms the field schema props to a TypeScript type */
export type InfoBannerFieldProps = typeof InfoBannerFieldSchema.type;

/** The final schema used for the field extension */
export const InfoBannerSchema = InfoBannerFieldSchema.schema;
